import { ReactElement, useEffect, useState } from 'react';

import clsx from 'clsx';
import { motion, Variants } from 'framer-motion';

import { useWindowSizeStore } from '../../../stores/useWindowSizeStore';
import { CaretDownIcon } from '../../icons/CaretDownIcon';
import { ContentHandlerPurchaseSummary } from './ContentHandlerPurchaseSummary';

export function EmpresaSummary(): ReactElement {
  const width = useWindowSizeStore(state => state.width);
  const [isOpen, setIsOpen] = useState(width >= 748 ? true : false);

  const variants: Variants = {
    open: {},
    closed: { height: 180 },
  };

  function toggleIsOpen() {
    setIsOpen(prevState => !prevState);
  }

  useEffect(() => {
    if (width >= 748) {
      setIsOpen(true);
    }
  }, [width]);

  return (
    <div className="h-full flex flex-col gap-8 mx-auto max-[748px]:w-full w-[40%]">
      <motion.section
        variants={variants}
        initial={false}
        animate={isOpen ? 'open' : 'closed'}
        className="min-[748px]:w-[400px] max-[748px]:w-full h-[250px] bg-white rounded-xl shadow-card p-6 flex flex-col justify-between"
      >
        <ContentHandlerPurchaseSummary isPurchaseSummaryOpen={isOpen} />
        {width < 748 && (
          <div className="flex justify-center mt-8">
            <button className="flex gap-1 p-1" onClick={toggleIsOpen}>
              <CaretDownIcon
                className={clsx('stroke-neutral-700', isOpen && 'rotate-180')}
              />
              <span className="text-primary-main">
                {isOpen ? 'Mostrar resumo' : 'Ver detalhes'}
              </span>
            </button>
          </div>
        )}
      </motion.section>
    </div>
  );
}
